<style scoped>
.visa-frame {
  margin: 32px;
  width: 90%;
}
@media only screen and (max-width: 480px) {
  .visa-frame {
    margin: 32px 0px;
  }
}

</style>

<template>
  <div> 
    <div class="centered-child" style="padding-bottom: 16px">
      <div style="width: 40%; max-width: 200px">
        <img src="/static/paypal.svg">
      </div>
    </div>

    <div v-if="!paymentDone">
      <div style="padding: 16px"><h2>Payment with Paypal</h2></div>

      <md-card v-if="$route.params.cart == 'CRRV'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Standard - 299&euro; TTC</div>
            <div class="md-subhead">Appeal to the Appeals Board on Visa Refusals</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>


      <md-card v-if="$route.params.cart == 'PREMIUM'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Premium - 999&euro; TTC</div>
            <div class="md-subhead">I am assisted and defended by a lawyer </div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/lawyer.svg">
          </md-card-media>
        </md-card-header>
      </md-card>
      

      <div class="light-frame visa-frame" >

        <div class="centered-child" style="margin-top: 32px" >

          <form v-if="$route.params.cart == 'CRRV'" action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick">
            <input type="hidden" name="business" value="team-visa@getmyvisatofrance.com">
            <input type="hidden" name="lc" value="US">
            <input type="hidden" name="item_name" value="Offre Standard CRRV">
            <input type="hidden" name="amount" value="299.00">
            <input type="hidden" name="currency_code" value="EUR">
            <input type="hidden" name="button_subtype" value="services">
            <input type="hidden" name="no_note" value="0">
            <input type="hidden" name="bn" value="PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest">
            <input type="image" src="https://www.paypalobjects.com/fr_XC/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal - la solution de paiement en ligne la plus simple et la plus sécurisée !">
            <img alt="" border="0" src="https://www.paypalobjects.com/fr_XC/i/scr/pixel.gif" width="1" height="1">
          </form>



          <form v-if="$route.params.cart == 'PREMIUM'" action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick">
            <input type="hidden" name="business" value="team-visa@getmyvisatofrance.com">
            <input type="hidden" name="lc" value="US">
            <input type="hidden" name="item_name" value="Offre Premium">
            <input type="hidden" name="amount" value="999.00">
            <input type="hidden" name="currency_code" value="EUR">
            <input type="hidden" name="button_subtype" value="services">
            <input type="hidden" name="no_note" value="0">
            <input type="hidden" name="bn" value="PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest">
            <input type="image" src="https://www.paypalobjects.com/fr_XC/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal - la solution de paiement en ligne la plus simple et la plus sécurisée !">
            <img alt="" border="0" src="https://www.paypalobjects.com/fr_XC/i/scr/pixel.gif" width="1" height="1">
          </form>

        </div>

        <!--<div class="centered-child" style="margin-top: 24px">
          <md-button class="md-raised md-primary large-button" 
          @click="onClickPay()"
          :disabled="loading">
            <span>Payer</span> 
          </md-button>
        </div>-->
      </div>

 
    </div>
    <div v-else>
        
        <div class="centered-child" style="margin-top: 48px">
          <md-button class="md-raised md-primary large-button"
           @click="onClickContinue()"
           >Continue</md-button>
        </div>


    </div>
  </div>
</template>

<script>

import ServiceAccess from '../service/ServiceAccess'

export default {
  data: function () {
    return {
      loading: false,
      paymentDone: false
    }
  },






  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)
    


    let promises = [
      ServiceAccess.instance.loadValues(this.$route.params.sessionId)
    ]
    Promise.all(promises).then(responses => {
      let [values] = responses
      this.values = values
    })
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    prevScreen: function () {
      this.$router.back()
    },

    onClickPay: function () {   
      this.loading = true

      ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-pay', {kind: 'wire'})

      ServiceAccess.instance.checkout(this.$route.params.sessionId, null, this.$route.params.cart).then(resp => {
        ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-stripe-success')
        this.loading = false
        this.paymentDone = true
        this.trackAdsConversion()
      }, err => {
        ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-stripe-error')
        this.loading = false
        console.error('Failed Stripe checkout: ', err)

      })

    },

    trackAdsConversion: function () {
      /* eslint-disable camelcase */
      /* eslint-disable no-unused-vars */
      var google_conversion_id = 865811613
      var google_conversion_language = 'en'
      var google_conversion_format = '3'
      var google_conversion_color = 'ffffff'
      var google_conversion_label = 'IzYDCM7i4WwQnfnsnAM'
      var google_remarketing_only = false
      
      var script = document.createElement('script')
      script.src = '//www.googleadservices.com/pagead/conversion.js'

      var image = new global.Image(1, 1)
      image.src = '//www.googleadservices.com/pagead/conversion/865811613/?label=IzYDCM7i4WwQnfnsnAM&amp;guid=ON&amp;script=0'
    },



    onClickContinue: function () {
      this.$router.replace('/f/' + this.$route.params.sessionId + '/')
    }

  }


}
</script>


// WEBPACK FOOTER //
// CheckoutPaypal.vue?1c614104